<template>
  <div>
    <PCNavbar />
    <MobileNavBar />
    <div class="document-page">
    <div class="document-header">
      <h1>资料下载</h1>
      <p>提供各类文档资料下载</p>
    </div>

    <div class="document-container">
      <!-- 面包屑导航 -->
      <div class="breadcrumb-nav" v-if="folderPath.length > 1">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item
            v-for="(item, index) in folderPath"
            :key="item.id"
            @click="navigateToFolder(index)"
            style="cursor: pointer"
          >
            {{ item.name }}
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <!-- 搜索区域 -->
      <div class="search-box">
        <el-input
          v-model="searchQuery.fileName"
          placeholder="搜索文件名"
          class="search-input"
          clearable
          @keyup.enter="handleSearch"
        >
          <template #append>
            <el-button @click="handleSearch">搜索</el-button>
          </template>
        </el-input>
        
        <el-select
          v-model="searchQuery.fileType"
          placeholder="文件类型"
          clearable
          class="type-select"
          @change="handleSearch"
        >
          <el-option label="全部" value="" />
          <el-option label="PDF" value="pdf" />
          <el-option label="Word" value="doc" />
          <el-option label="Word" value="docx" />
          <el-option label="Excel" value="xls" />
          <el-option label="Excel" value="xlsx" />
          <el-option label="ZIP" value="zip" />
          <el-option label="JPG" value="jpg" />
          <el-option label="JPEG" value="jpeg" />
          <el-option label="PNG" value="png" />
          <el-option label="GIF" value="gif" />
          <el-option label="WEBP" value="webp" />
        </el-select>

        <el-button v-if="folderPath.length > 1" @click="goBack">
          返回上级
        </el-button>
      </div>

      <!-- 文件和文件夹列表 -->
      <div class="document-list" v-loading="loading">
        <!-- 文件夹 -->
        <div
          v-for="folder in folderList"
          :key="'folder-' + folder.id"
          class="document-item folder-item"
          @click="openFolder(folder)"
        >
          <div class="doc-icon">
            <svg viewBox="0 0 1024 1024" width="48" height="48" fill="#409eff">
              <path d="M853.333333 256H469.333333l-85.333333-85.333333H170.666667c-46.933333 0-85.333333 38.4-85.333334 85.333333v512c0 46.933333 38.4 85.333333 85.333334 85.333333h682.666666c46.933333 0 85.333333-38.4 85.333334-85.333333V341.333333c0-46.933333-38.4-85.333333-85.333334-85.333333z"></path>
            </svg>
          </div>
          <div class="doc-info">
            <h3>{{ folder.folderName }}</h3>
            <p class="doc-desc">{{ folder.description || '文件夹' }}</p>
            <div class="doc-meta">
              <span>📁 文件夹</span>
            </div>
          </div>
        </div>

        <!-- 文件 -->
        <div
          v-for="doc in documentList"
          :key="'file-' + doc.id"
          class="document-item"
        >
          <div class="doc-icon">
            <span :style="{ fontSize: '48px', color: getFileColor(doc.fileType) }">
              {{ getFileIcon(doc.fileType) }}
            </span>
          </div>
          <div class="doc-info">
            <h3>{{ doc.fileName }}</h3>
            <p class="doc-desc">{{ doc.description || '暂无描述' }}</p>
            <div class="doc-meta">
              <span v-if="doc.fileType">📄 {{ doc.fileType.toUpperCase() }}</span>
              <span v-if="doc.fileSize">💾 {{ formatFileSize(doc.fileSize) }}</span>
              <span v-if="doc.downloadCount !== undefined">⬇️ {{ doc.downloadCount }}次</span>
              <span v-if="doc.createTime">📅 {{ formatDate(doc.createTime) }}</span>
            </div>
          </div>
          <div class="doc-action">
            <el-button type="primary" @click="handleDownload(doc)">
              下载
            </el-button>
          </div>
        </div>

        <el-empty v-if="!loading && folderList.length === 0 && documentList.length === 0" description="暂无资料" />
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import { listFolderByParentId, listDocumentByFolderId, getDownloadUrl } from '../api/document';
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'

export default {
  name: 'Document',
  components: {
    PCNavbar,
    MobileNavBar
  },
  data() {
    return {
      loading: false,
      currentFolderId: 0,
      folderPath: [{ id: 0, name: '根目录' }],
      folderList: [],
      documentList: [],
      searchQuery: {
        fileName: '',
        fileType: ''
      }
    };
  },
  mounted() {
    this.loadCurrentFolder();
  },
  methods: {
    async loadCurrentFolder() {
      this.loading = true;
      try {
        // 加载子文件夹
        const folderRes = await listFolderByParentId(this.currentFolderId);
        console.log('文件夹响应:', folderRes);
        if (folderRes && folderRes.data) {
          // 处理不同的响应格式
          const folderData = folderRes.data.data || folderRes.data;
          this.folderList = Array.isArray(folderData) ? folderData : [];
        } else {
          this.folderList = [];
        }

        // 加载文件
        const fileRes = await listDocumentByFolderId(this.currentFolderId);
        console.log('文件响应:', fileRes);
        if (fileRes && fileRes.data) {
          // 处理不同的响应格式
          const fileData = fileRes.data.data || fileRes.data;
          this.documentList = Array.isArray(fileData) ? fileData : [];
        } else {
          this.documentList = [];
        }
        
        console.log('文件夹列表:', this.folderList);
        console.log('文件列表:', this.documentList);
      } catch (error) {
        console.error('加载失败', error);
        this.$message.error('加载失败: ' + (error.message || '未知错误'));
        this.folderList = [];
        this.documentList = [];
      } finally {
        this.loading = false;
      }
    },
    openFolder(folder) {
      this.currentFolderId = folder.id;
      this.folderPath.push({ id: folder.id, name: folder.folderName });
      this.loadCurrentFolder();
    },
    navigateToFolder(index) {
      this.folderPath = this.folderPath.slice(0, index + 1);
      this.currentFolderId = this.folderPath[index].id;
      this.loadCurrentFolder();
    },
    goBack() {
      if (this.folderPath.length > 1) {
        this.folderPath.pop();
        this.currentFolderId = this.folderPath[this.folderPath.length - 1].id;
        this.loadCurrentFolder();
      }
    },
    handleSearch() {
      // 搜索功能暂时简化，只在当前文件夹搜索
      this.loadCurrentFolder();
    },
    handleDownload(doc) {
      const downloadUrl = '/dev-api' + getDownloadUrl(doc.id);
      window.open(downloadUrl, '_blank');
    },
    getFileIcon(fileType) {
      if (!fileType) return '📄';
      const iconMap = {
        pdf: '📕',
        doc: '📘',
        docx: '📘',
        xls: '📗',
        xlsx: '📗',
        ppt: '📙',
        pptx: '📙',
        zip: '📦',
        rar: '📦',
        txt: '📄',
        jpg: '🖼️',
        jpeg: '🖼️',
        png: '🖼️',
        gif: '🖼️',
        bmp: '🖼️',
        webp: '🖼️',
        svg: '🖼️'
      };
      return iconMap[fileType.toLowerCase()] || '📄';
    },
    getFileColor(fileType) {
      if (!fileType) return '#909399';
      const colorMap = {
        pdf: '#f56c6c',
        doc: '#409eff',
        docx: '#409eff',
        xls: '#67c23a',
        xlsx: '#67c23a',
        ppt: '#e6a23c',
        pptx: '#e6a23c',
        zip: '#909399',
        rar: '#909399',
        txt: '#606266',
        jpg: '#e6a23c',
        jpeg: '#e6a23c',
        png: '#409eff',
        gif: '#67c23a',
        bmp: '#909399',
        webp: '#409eff',
        svg: '#f56c6c'
      };
      return colorMap[fileType.toLowerCase()] || '#909399';
    },
    getFileIconClass(fileType) {
      const iconMap = {
        pdf: 'el-icon-document',
        doc: 'el-icon-document',
        docx: 'el-icon-document',
        xls: 'el-icon-tickets',
        xlsx: 'el-icon-tickets',
        ppt: 'el-icon-present',
        pptx: 'el-icon-present',
        zip: 'el-icon-folder-opened',
        rar: 'el-icon-folder-opened'
      };
      const iconClass = iconMap[fileType.toLowerCase()] || 'el-icon-document';
      const colorMap = {
        pdf: '#f56c6c',
        doc: '#409eff',
        docx: '#409eff',
        xls: '#67c23a',
        xlsx: '#67c23a',
        ppt: '#e6a23c',
        pptx: '#e6a23c',
        zip: '#909399',
        rar: '#909399'
      };
      const color = colorMap[fileType.toLowerCase()] || '#909399';
      return iconClass + ' ' + 'file-icon-' + fileType.toLowerCase();
    },
    formatFileSize(bytes) {
      if (bytes === 0) return '0 B';
      const k = 1024;
      const sizes = ['B', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
    },
    formatDate(dateStr) {
      if (!dateStr) return '';
      return dateStr.split(' ')[0];
    }
  }
};
</script>

<style lang="scss" scoped>
.document-page {
  min-height: 100vh;
  background: #f5f7fa;
  padding-top: 80px;
}

.document-header {
  text-align: center;
  padding: 60px 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;

  h1 {
    font-size: 48px;
    margin-bottom: 20px;
  }

  p {
    font-size: 20px;
    opacity: 0.9;
  }
}

.document-container {
  max-width: 1200px;
  margin: -40px auto 60px;
  padding: 0 20px;
}

.breadcrumb-nav {
  background: white;
  padding: 15px 20px;
  border-radius: 10px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}

.search-box {
  background: white;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  display: flex;
  gap: 20px;
  margin-bottom: 30px;

  .search-input {
    flex: 1;
  }

  .type-select {
    width: 200px;
  }
}

.document-list {
  min-height: 400px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
}

.document-item {
  background: white;
  padding: 25px;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  transition: all 0.3s;
  cursor: pointer;

  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
    transform: translateY(-2px);
  }

  &.folder-item {
    cursor: pointer;
    
    &:hover {
      background: #f0f9ff;
    }
  }

  .doc-icon {
    margin-bottom: 15px;
  }

  .doc-info {
    flex: 1;
    width: 100%;

    h3 {
      font-size: 16px;
      margin-bottom: 8px;
      color: #303133;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .doc-desc {
      color: #909399;
      font-size: 13px;
      margin-bottom: 10px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .doc-meta {
      display: flex;
      flex-direction: column;
      gap: 5px;
      font-size: 12px;
      color: #909399;

      span {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .doc-action {
    margin-top: 15px;
    
    .el-button {
      padding: 10px 20px;
    }
  }
}

@media screen and (max-width: 768px) {
  .document-header {
    padding: 40px 20px;

    h1 {
      font-size: 32px;
    }

    p {
      font-size: 16px;
    }
  }

  .search-box {
    flex-direction: column;

    .type-select {
      width: 100%;
    }
  }

  .document-list {
    grid-template-columns: 1fr;
  }
}
</style>
